'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.myscripts.add', [])
  .controller('MyScriptsAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/myscripts/add/index.js